import { render, staticRenderFns } from "./SubmissionTogglerModalV2.vue?vue&type=template&id=2b6b0f6a&scoped=true&"
import script from "./SubmissionTogglerModalV2.vue?vue&type=script&lang=js&"
export * from "./SubmissionTogglerModalV2.vue?vue&type=script&lang=js&"
import style0 from "./SubmissionTogglerModalV2.vue?vue&type=style&index=0&id=2b6b0f6a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6b0f6a",
  null
  
)

export default component.exports